import Vue from 'vue';
import Main from './main.vue';
import store from '@/store'
import router from '@/router'

const LoginBoxConstructor = Vue.extend(Main);
let instance;
const LoginBox = function(options){
    if(document.getElementById('ycyLogin')){
        return;
    }
    options = options || {};
    instance = new LoginBoxConstructor({
        data: options,
        store,
        router
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
    instance.visible = true;
}

export default LoginBox;


// WEBPACK FOOTER //
// ./src/components/LoginBox/src/main.js